import { LinksForm } from "./LinksForm";

export const Links = () => {

  return (
    <>
      <LinksForm />
    </>
  )
}